import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import Loading from "../Loading";
import UserStore from '../../store/User';

const LogoutPage = function () {
  const dispatch : AppDispatch = useDispatch();
  
  useEffect(() => {
      dispatch(UserStore.actions.userSignedOut());
  }, [dispatch]);

    return (
      <Loading isLoading={true} />
    );
}

export default LogoutPage;